import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaArrowLeft, FaCheckCircle, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import pressReleaseImage from '../img/press-release.jpg';

const AdvertismentPage = () => {
  const services = [
    {
      id: 'advertisement',
      image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      icon: "fas fa-ad",
      title: "Advertisement",
      description: "Creative and strategic advertising solutions across digital and traditional media to maximize your brand visibility and customer reach.",
      longDescription: [
        "Comprehensive ad campaign planning and execution",
        "Multi-platform advertising (social media, search engines, display networks)",
        "Target audience analysis and segmentation",
        "3D Advertising",
        "Print Media Advertising"
      ],
      stats: [
        { value: "300+", label: "Campaigns Managed" },
        { value: "85%", label: "Client Retention" },
        { value: "24/7", label: "Support" }
      ]
    },
    {
      id: 'marketing',
      image: "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      icon: "fas fa-bullseye",
      title: "Marketing",
      description: "Comprehensive marketing strategies tailored to your business goals.",
      longDescription: [
        "Digital marketing strategy development",
        "Content marketing and SEO services",
        "Digital Billboards",
        "Email marketing automation",
        "Search Engine Marketing"
      ],
      stats: [
        { value: "500+", label: "Satisfied Clients" },
        { value: "3x", label: "Average ROI" },
        { value: "360°", label: "Approach" }
      ]
    },
    {
      id: 'press-release',
      image: pressReleaseImage,
      icon: "fas fa-newspaper",
      title: "Press Release",
      description: "Professional press release writing and distribution services.",
      longDescription: [
        "Newsworthy press release writing",
        "Media distribution to relevant outlets",
        "Crisis communication management",
        "Media relationship building",
        "Press conference coordination"
      ],
      stats: [
        { value: "1000+", label: "Media Contacts" },
        { value: "95%", label: "Pickup Rate" },
        { value: "48h", label: "Turnaround" }
      ]
    }
  ];

  const { serviceId } = useParams();
  const service = services.find(s => s.id === serviceId);

  if (!service) {
    return <div className="container py-5 text-center">Service not found</div>;
  }

  return (
    
    <div className="our-services-page">

      {/* Hero Section */}
      <section className="service-hero" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${service.image})` }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center text-white">
              <Link to="/services" className="btn btn-outline-light mb-4"> {/* Changed from "/services" to "/" */}
                <FaArrowLeft className="me-2" /> Back to Services
              </Link>
              <h1 className="display-4 fw-bold mb-3">{service.title}</h1>
              <p className="lead">{service.description}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Service Details */}
      <section className="py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-8">
              <h2 className="fw-bold mb-4">Service Overview</h2>
              <div className="service-features mb-5">
                {service.longDescription.map((feature, index) => (
                  <div key={index} className="d-flex mb-3">
                    <FaCheckCircle className="text-primary mt-1 me-3" size={20} />
                    <p className="mb-0">{feature}</p>
                  </div>
                ))}
              </div>

              <div className="service-stats bg-light p-4 rounded-3 mb-5">
                <h3 className="fw-bold mb-4">Why Choose Us</h3>
                <div className="row text-center">
                  {service.stats.map((stat, index) => (
                    <div key={index} className="col-md-4 mb-3 mb-md-0">
                      <div className="display-5 fw-bold text-primary">{stat.value}</div>
                      <div className="text-muted">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service-contact-card bg-primary text-white p-4 rounded-3 shadow">
                <h3 className="fw-bold mb-4">Get Started</h3>
                <p className="mb-4">Ready to elevate your {service.title.toLowerCase()} strategy? Contact us today for a free consultation.</p>

                <div className="mb-4">
                  <div className="d-flex align-items-center mb-3">
                    <FaPhoneAlt className="me-3" />
                    <span>+1 (613) 915-9806</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <FaEnvelope className="me-3" />
                    <span>contact@vibex.media</span>
                  </div>
                </div>

                <Link to="/get-started">
                  <button className="btn btn-light w-100 py-2 fw-bold">
                    Request a Quote
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="fw-bold mb-5 text-center">Explore Our Other Services</h2>
          <div className="row g-4">
            {services.filter(s => s.id !== serviceId).map(service => (
              <div key={service.id} className="col-md-6">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="row g-0">
                    <div className="col-md-4">
                      <img src={service.image} className="img-fluid h-100 rounded-start" alt={service.title} style={{ objectFit: 'cover' }} />
                    </div>
                    <div className="col-md-8">
                      <div className="card-body">
                        <h5 className="card-title fw-bold">{service.title}</h5>
                        <p className="card-text text-muted">{service.description}</p>
                        <Link to={`/our-services/${service.id}`} className="btn btn-sm btn-outline-primary">
                          Learn More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdvertismentPage;